import { put, takeLatest } from 'redux-saga/effects';
import _data from '../utils/_data';
import Constants from '../utils/constants';
import '../app-actions';

import { getAction, postAction, updateAction, deleteAction, handleResponse, errorHandler } from '../saga';

export function* checkSubscription(action) {
    if (_data.token) {
        let endpoint;
        if (Constants.simulate.IOS_SUBSCRIPTION || Constants.simulate.ANDROID_SUBSCRIPTION || Constants.simulate.CHARGEBEE_SUBSCRIPTION) {
            endpoint = `http://localhost:4000/subscriptions/${Constants.simulate.CHARGEBEE_SUBSCRIPTION ? 'web' : Constants.simulate.IOS_SUBSCRIPTION ? 'ios' : 'android'}`;
        } else {
            endpoint = `${Project.api}/subscriptions/check-subscription/`;
        }
        yield getAction(action, endpoint, 'CHECK_SUBSCRIPTION', false, res => ({ subscriptions: res.subscriptions, whitelisted: res.whitelisted }));
    }
}

export function* createSubscription(action) {
    yield postAction(action, `${Project.api}/subscriptions/`, 'CREATE_SUBSCRIPTION', false, res => ({ subscriptions: res.subscriptions, whitelisted: res.whitelisted }));
}

export function* getNextSubscription(action) {
    yield getAction(action, `${Project.api}/subscriptions/next-subscription/`, 'GET_NEXT_SUBSCRIPTION');
}

export function* updateNextSubscription(action) {
    yield updateAction(action, `${Project.api}/subscriptions/next-subscription/`, 'UPDATE_NEXT_SUBSCRIPTION');
}

export function* cancelSubscription(action) {
    yield deleteAction(action, `${Project.api}/subscriptions/next-subscription/`, 'CANCEL_SUBSCRIPTION');
}

export function* getCurrency(action) {
    if (Constants.simulate.FORCE_CURRENCY) {
        return yield put({ type: 'GET_CURRENCY_LOADED', data: Constants.simulate.FORCE_CURRENCY });
    }
    yield getAction(action, `${Project.api}/subscriptions/currency`, 'GET_CURRENCY');
}

export function* getCountry(action) {
    yield getAction(action, `${Project.api}/subscriptions/country`, 'GET_COUNTRY');
}

export function* getCoupons(action) {
    yield getAction(action, `${Project.api}/subscriptions/coupons`, 'GET_COUPONS', false, res => {
        const filteredCoupons = res.filter(coupon => Constants.autoApplyCouponsWithPrefix.some((couponPrefix) => {
            return coupon.id.includes(couponPrefix)
        }));

        return filteredCoupons
    });
}

export function* getCoupon(action) {
    const prefix = 'GET_COUPON';
    try {
        const data = yield _data.get(`${Project.api}/subscriptions/coupons/${encodeURIComponent(action.id)}`);    
        if (data.coupon.status !== 'active') {
            return yield errorHandler(action, prefix, false, new Error('Sorry that coupon code is invalid.'));
        }
        return yield handleResponse(action, prefix, data, false, res => res.coupon, true);
    } catch (e) {
        yield errorHandler(action, prefix, false, e);
    }
}

export function* getCouponApplied(action) {
    const prefix = 'GET_COUPON_APPLIED';
    try {
        const data = yield _data.get(`${Project.api}/subscriptions/coupons/${encodeURIComponent(action.id)}`);    
        return yield handleResponse(action, prefix, data, false, res => res.coupon, true);
    } catch (e) {
        yield errorHandler(action, prefix, false, e);
    }
}

export default [
    takeLatest(Actions.CHECK_SUBSCRIPTION, checkSubscription),
    takeLatest(Actions.CREATE_SUBSCRIPTION, createSubscription),
    takeLatest(Actions.GET_NEXT_SUBSCRIPTION, getNextSubscription),
    takeLatest(Actions.UPDATE_NEXT_SUBSCRIPTION, updateNextSubscription),
    takeLatest(Actions.CANCEL_SUBSCRIPTION, cancelSubscription),
    takeLatest(Actions.GET_CURRENCY, getCurrency),
    takeLatest(Actions.GET_COUNTRY, getCountry),
    takeLatest(Actions.GET_COUPONS, getCoupons),
    takeLatest(Actions.GET_COUPON, getCoupon),
    takeLatest(Actions.GET_COUPON_APPLIED, getCouponApplied),
];
